<template>
	<div id="dashboard-surveys">

		<div class="requested-surveys" v-if="onGoingSurveys.length > 0">	
			<div class="dash__section-title dash__section-title--surveys">Ongoing Surveys</div>
			<SurveyPost 
				v-for="(surveyData, i) in onGoingSurveys"
				v-if="i < onGoingSurveysRenderGetSize" 
				:key="surveyData.survey.quoteReference + '-a'" 
				:surveyData="surveyData"
				v-on:openCloseToggle="toggleMoreInfo"
				:toggled="toggled"
				:isAdmin="isAdmin"
			/>
			<!-- show more from store -->
			<div v-if="onGoingSurveysRenderGetSize < onGoingSurveys.length">
				<button class="btn btn-small" @click="onGoingSurveysRenderGetSize += onGoingSurveysIncAmount">Load more</button>
			</div>
		
		</div>

		<div class="completed-surveys" v-if="completedSurveys.length > 0">	
			<div class="dash__section-title dash__section-title--surveys">Completed Surveys</div>
			<CompletedSurvey 
				v-for="(surveyData, i) in completedSurveys"
				v-if="i < completedSurveysRenderGetSize" 
				:key="surveyData.survey.quoteReference + '-b'" 
				:surveyData="surveyData"
				v-on:openCloseToggle="toggleMoreInfo"
				:toggled="toggled"
				:isAdmin="isAdmin"
			/>
			<!-- show more from store -->
			<div>
				<button class="btn btn-small" 
					@click="completedSurveysRenderGetSize += completedSurveysIncAmount"
					v-if="completedSurveys.length > completedSurveysRenderGetSize"
				>
					Load more
				</button>
				<button class="btn btn-small" 
					@click="loadMoreCompletedSurveys(completedSurveyPage += 1)"
					v-if="completedSurveys.length <= completedSurveysRenderGetSize && shouldLoadMore && completedSurveys.length >= 100">
					Load more
				</button>
			</div>
		
		</div>

	</div>
</template>

<script>

// import CreateProgressBar from '../common/Create/CreateProgressBar';
// import LoginPanel from '../common/Login/LoginPanel';
import SurveyPost from '@/components/common/Dashboard/SurveyPost';
import CompletedSurvey from '@/components/common/Dashboard/CompletedSurvey';

export default {
	components : {
		SurveyPost,
		CompletedSurvey
	},
	data(){
		return {
			toggled : "",
			onGoingSurveysRenderGetSize : 10,
			onGoingSurveysIncAmount : 10,
			completedSurveysRenderGetSize : 10,
			completedSurveysIncAmount : 10,
			completedSurveyPage : 1,
			shouldLoadMore : true
		}
	},
	computed : {
		onGoingSurveys(){
			return this.$store.getters.getOnGoingSurveys
		},
		completedSurveys(){
			return this.$store.getters.getCompletedSurveys

		},
		userInfo(){
			return this.$store.getters.getUserInfo
		},
		isAdmin(){
			return this.userInfo.role === 'admin'
		}
			
	},
	methods : {
		toggleMoreInfo(quoteReference){
		
			if(this.toggled === quoteReference){
				this.toggled = '';
			} else {
				this.toggled = quoteReference
			}
		},
		loadMoreCompletedSurveys(page){
			this.$store.dispatch('loadExtraCompletedSurveys', page)
			.then((loadMore) => {
				if(!loadMore){
					this.shouldLoadMore = false;
				} else {
					this.completedSurveysRenderGetSize += this.completedSurveysIncAmount
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DashboardSurveys.vue